import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d5b876e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b876e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5b876e')) {
      api.createRecord('0d5b876e', component.options)
    } else {
      api.reload('0d5b876e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0d5b876e&scoped=true&", function () {
      api.rerender('0d5b876e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/CustomPitLocation/modules/table-list/index.vue"
export default component.exports